// extracted by mini-css-extract-plugin
export default {"CodeControlsContainer":"CodeControls_CodeControlsContainer__zgELe","buttonWrapper":"CodeControls_buttonWrapper__QDccy"};